import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { startEmrSession } from '@/api/adapters/emr';
import { useAuthStore } from '@/app/store/auth.store';
import { EmrNotice } from './EmrNotice';

/**
 * `/emr-bridge?emr_token=…` — the page the hospital EMR opens (SHCT-994, api-contracts/emr-bridge.md §B.4).
 * The token is read once and dropped from the address bar before anything else happens (plan D24), exchanged once
 * (StrictMode-safe, see startEmrSession), then the page replaces itself with the patient's view so Back never
 * returns here.
 */
export function EmrBridgePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const loginEmr = useAuthStore((s) => s.loginEmr);
  const [token] = useState(() => searchParams.get('emr_token'));
  const [failed, setFailed] = useState(!token);

  // Keyed on the token alone: `navigate` changes identity with the location, and the strip below changes the
  // location, so listing it would re-run the exchange.
  useEffect(() => {
    navigate('/emr-bridge', { replace: true });
    if (!token) return;
    let active = true;
    startEmrSession(token).then(
      (session) => {
        if (!active) return;
        loginEmr(session.email, session.name, session.role, session.patientUid);
        navigate(`/emr/patients/${encodeURIComponent(session.patientUid)}`, { replace: true });
      },
      () => {
        if (active) setFailed(true);
      },
    );
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return <EmrNotice kind={failed ? 'failed' : 'loading'} />;
}
